export default {"src":"/_next/static/media/icon_nav_dd_grants_off.a40262cc.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};